export default __webpack_public_path__ + "static/media/AlbertaLovelace.870a9d43.png";